import {
  Button,
  Divider,
  Flex,
  Image,
  Progress,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/core";
import React, { Fragment } from "react";

function ProfileCard({ profile }) {
  return (
    // <Box backgroundColor="#eeeeee" m="10" marginLeft="0" p="5" width="auto">
    <Fragment>
      <Flex
        align={{ base: "center" }}
        direction={{ lg: "row", md: "column", sm: "column", xs: "column" }}
      >
        <Image rounded="1em" src={profile.img} size="100px" />
        <Flex direction="column" marginLeft="1em" marginTop="0.5em">
          <Flex justify="space-between">
            <Text fontSize="lg">{profile.name}</Text>
            <Button size="sm" variant="ghost">
              Update
            </Button>
          </Flex>
          <Text fontSize="0.9em" marginTop="0.35em">
            {profile.headline}
          </Text>
          <Stack marginY="1.2em">
            <SimpleGrid gridTemplateColumns="0.8fr 0.2fr" spacing="1em">
              <Text fontSize="sm">{`Profile Strength (${profile.comment})`}</Text>
              <Text color="green">{`${profile.strength} %`}</Text>
            </SimpleGrid>
            <Progress
              height="0.25em"
              backgroundColor="black"
              color="green"
              size="sm"
              value={profile.strength}
            />
          </Stack>
        </Flex>
      </Flex>
      <SimpleGrid minChildWidth="120px" marginY="1em" spacing="1em">
        <Flex as="span" align="center" fontSize="sm">
          {" "}
          <Text marginRight="0.5em" fontSize="lg" color="#41bb93">
            {profile.jobs.recommended.count}
          </Text>
          Recommended{" "}
        </Flex>
        <Flex as="span" align="center" fontSize="sm">
          {" "}
          <Text marginRight="0.5em" fontSize="lg" color="#41bb93">
            {profile.jobs.applied.count}
          </Text>
          Applied{" "}
        </Flex>
      </SimpleGrid>
      <Divider borderColor="black.200" />
    </Fragment>
    // </Box>
  );
}

export default ProfileCard;
